<template>
  <div class="mt20 minW1500">
    <div class="batch_container">
      <a-checkbox :checked="isCheckAll" @change="checkAllOrder" :disabled="false">全选</a-checkbox>
      <a-space :size="10" class="ml16">
        <a-button
          :disabled="checkedList.length === 0"
          @click="showChangeGift">批量添加包装</a-button>
      </a-space>
      <a-space :size="10" class="ml16">
               <a-button
                         :disabled="checkedList.length === 0"
                         :loading="isSubmitOrder"
                         @click="generateOrder">批量生成订单</a-button>
      </a-space>
<!--      <a-space :size="10" class="ml16">-->
<!--        <a-button-->
<!--          :disabled="checkedList.length === 0"-->
<!--          @click="showPay(0)">批量付款</a-button>-->
<!--      </a-space>-->
      <tip text="亲，加急订单建议您直接联系商家下单代发哦！" />
    </div>
    <a-checkbox-group v-model="checkedList"
                      @change="checkOrder">

      <table v-if="tableData.length > 0"
             style="width:100%;">
        <tbody class="ant-table-tbody">
          <a-row>
            <a-col :span="13" class="title_font text_center">商品信息</a-col>
            <a-col :span="2" class="title_font text_center">包装状态</a-col>
            <a-col :span="5" class="title_font text_center">物流</a-col>
            <a-col :span="4" class="title_font text_center">操作</a-col>
          </a-row>
          <span class="list" v-for="(item,index) in tableData" :key="item.id">
            <tr  class="first_row_container">
              <td>
                <div>
                  <a-row type="flex" align="middle" style="height: 40px">
                    <a-col :span="1" style="width: 30px">
                      <a-checkbox :value="item.id" :disabled="item.order_status>1"/>
                    </a-col>
                    <a-col :span="4">
                      <span>订单号:{{item.sn}}</span>
                    </a-col>
                    <a-col :span="4">
                      <span>下单时间：{{item.created_at}}</span>
                    </a-col>
                    <a-col :span="4">
                      <span>支付时间：{{item.payed_at}}</span>
                    </a-col>
                    <a-col :span="7">
                      <span>
                        订单备注：{{item.msg}}
                        <a href="javascript:void(0)" class="edit_button" @click="showChangeMsg(item.id,item.msg)">修改</a>
                      </span>
                    </a-col>
                    <a-col :span="3">
                      <span>
                        <a-button v-if="(expressData.length>0)" @click="showChangeExpress(item)">修改快递公司</a-button>
                      </span>
                    </a-col>
                  </a-row>
                </div>
              </td>
            </tr>
            <tr  class="second_row_container">
              <td >
                <template v-for="(val) in item.stores[0].goods">
                  <div class="goods_info">
                    <a-row type="flex" align="middle">
                      <a-col :span="2">
                        <div class="goods_img img_wrapper">
                          <img :src="val.goods_image" width="100" height="100">
                        </div>
                      </a-col>
                      <a-col :span="4">
                        <a-row>
                          商品编码:{{val.goods_code}}
                        </a-row>
                        <a-row>
                          商品名称:{{val.goods_name}}
                        </a-row>
                        <a-row>
                          {{val.spec_name}}
                        </a-row>
                      </a-col>
                      <a-col :span="2" class="text_center">
                        {{val.price}}元
                      </a-col>
                      <a-col :span="1" class="text_center">
                        {{val.num}}件
                      </a-col>
                      <a-col :span="2" class="text_center">
                        {{val.weight}}KG
                      </a-col>
                      <a-col :span="2" class="text_center">
                        {{val.goods_id!==0?'已匹配':'未匹配'}}
                      </a-col>
                      <a-col :span="2" class="text_center">
<!--                        <a-tag :color="orderStatusColor[item.order_status]">{{orderStatus[item.order_status]}}</a-tag>-->
                        <a-tag :color="item.gift.length>0 ? 'green':'red'">{{item.gift.length>0?'已选择包装':'未选择包装'}}</a-tag>
                      </a-col>
                      <a-col :span="5" class="text_center">
                        <a-row v-for="oriEx in item.express" :key="oriEx.express_id">
                          {{oriEx.express_name}}  {{oriEx.shipping_code}}
                        </a-row>
                      </a-col>
                    </a-row>
                  </div>
                  <div v-if="val.goods_id!==0">
                    <a-descriptions :column="6">
                      <a-descriptions-item label="所属商家" :span="1">
                        {{val.store_91_name}}
                      </a-descriptions-item>
                      <a-descriptions-item label="拿货地址" :span="5">
                        {{val.store_take_address}}
                      </a-descriptions-item>
                    </a-descriptions>
                  </div>
                </template>

                <div class="address_wrapper">
                  <a-descriptions :column="1">
                    <a-descriptions-item label="收货人信息">
                      <div style="display: inline-flex;">
                        <span class="ellipsis receiver_span" style="width: 50px;">{{item.address.rec_name}}</span>
                        <span class="ellipsis receiver_span" style="width: 150px;">{{item.address.rec_phone}}</span>
                        <span class="ellipsis receiver_span" style="width: 500px;">{{item.address.rec_address}}</span>
                      </div>
                    </a-descriptions-item>
                  </a-descriptions>
                </div>
              </td>
            </tr>
          </span>
        </tbody>
      </table>
      <empty-data v-else
                  :desc="emptyDesc" />
    </a-checkbox-group>

    <a-modal v-model="visibleMsg" title="修改备注" @ok="changeMsg">
      <a-input v-model="msgForm.des" placeholder="请输入备注" />
    </a-modal>
    <a-modal v-if="orderItem.id != undefined" v-model="visibleExpress" title="修改快递公司" @ok="changeExpress(orderItem.id,orderItem.express[0].express_id)">
      <div>
        <a-radio-group v-model="orderItem.express[0].express_id">
          <a-radio v-for="ex in expressData" :key="ex.value" :value="ex.value" :disabled="ex.disabled">{{ex.label}}</a-radio>
        </a-radio-group>
      </div>
    </a-modal>

    <edit-order-address-modal v-model="visibleAddress" :oldForm="oldAddressForm"></edit-order-address-modal>

    <batch-setting-gift v-model="visibleGift" :order-ids="checkedList" @refreshData="getOrderList"></batch-setting-gift>

    <batch-pay v-model="visiblePay" :order-ids="payIds" @refreshData="getOrderList"></batch-pay>
  </div>
</template>

<script>
import Tip from './Tip.vue'
import EmptyData from '@/components/common/EmptyData.vue'
import EditOrderAddressModal from './EditOrderAddressModal.vue'
import BatchSettingGift from "./BatchSettingGift.vue";
import BatchPay from "./BatchPay.vue";
export default {
  name: 'PddList',
  components: { Tip,EmptyData,EditOrderAddressModal,BatchSettingGift,BatchPay},
  props: {
    tableData: {
      type: Array,
      required: true
    },
    platformName: {
      type: String,
      required: false,
      default: '淘宝订单'
    },
    emptyDesc: {
      type: String,
      required: false,
      default: '暂无未处理的已同步订单，请先同步指定时间段内的拼多多'
    },
    expressData: {
      type: Array,
      required: true
    },
    isSubmitOrder: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isCheckAll: false,
      checkedList: [],
      cacheItem: {},//取消编辑还原的缓存对象
      chooseData:[],
      visibleMsg: false,
      visibleAddress: false,
      visibleExpress:false,
      visibleGift: false,
      visiblePay: false,
      payIds: [],
      msgForm: {
        ids: '',
        des: ''
      },
      addressForm: {},
      orderItem: {},
      orderStatus: {
        0:'已作废',
        1:'待审核',
        2:'待付款',
        3:'待发货',
        4:'已发货'
      },
      orderStatusColor: {
        0:'red',
        1:'orange',
        2:'blue',
        3:'purple',
        4:'green'
      },
      oldAddressForm: {}
    }
  },
  created () {

  },
  watch: {
    checkedList:function (oldValue, newValue) {
      var _this = this;
      _this.chooseData = [];
      this.checkedList.forEach(id => {
        for(var i in _this.tableData){
          if(_this.tableData[i].id == id){
            _this.chooseData.push(_this.tableData[i])
          }
        }
      })
      this.$emit('refreshData',this.checkedList.length,_this.chooseData )
    },
    tableData:function (oldValue, newValue) {
      var _this = this;
      _this.chooseData = [];
      this.checkedList.forEach(id => {
        for(var i in _this.tableData){
          if(_this.tableData[i].id == id){
            _this.chooseData.push(_this.tableData[i])
          }
        }
      })
      this.$emit('refreshData',this.checkedList.length,_this.chooseData )
    }
  },
  mounted () {

  },
  methods: {
    btnClick: function (data) {
      if (data != this.cur) {
        this.cur = data;
      }
    },
    pageClick: function () {
      console.log('现在在' + this.cur + '页');
    },

    editItem (item) {
      this.cacheItem = JSON.parse(JSON.stringify(item))
      item.isEdit = !item.isEdit
    },
    confirmEdit (item) {
      if (this.cacheItem.goods.goods_weight !== item.goods.goods_weight ||
        this.cacheItem.goods.buy_num !== item.goods.buy_num ||
        this.cacheItem.address.value.province !== item.address.value.province) {
        const params = {
          orderList: []
        }
        params.orderList.push(this.handleSingleItemExpress(item))
        this.calcExpressFreight(params)
      }
      item.isEdit = false
    },
    checkAllOrder (e) {
      if (e.target.checked) {
        this.tableData.map(item => {
          if (item.order_status <= 1) {
            this.checkedList.push(item.id)
          }
        })
      } else {
        this.checkedList = []
      }
      this.isCheckAll = e.target.checked
      // console.log(this.checkedList);
    },
    checkOrder (checkedList) {
      // console.log(checkedList);
      this.isCheckAll = checkedList.length === this.tableData.length
      this.checkedList = checkedList;
      // console.log(this.checkedList);
    },
    handleSingleItemExpress (item) {
      const { order_id, goods, address } = item
      const { province } = address.value
      const { goods_weight, buy_num } = goods
      const weight = (goods_weight * buy_num).toFixed(3)

      const paramsItem = {
        order_id,
        weight,
        province_name: province,
      }
      item.express.detail.forEach(exp => {
        exp.price = '计算中...'
      })

      return paramsItem
    },
    calcExpressFreight (params) {
      this.$API.FunctionService.batchCalcExpressFreight(params).then(({ express_list }) => {
        express_list.forEach(exp => {
          const order = this.tableData.find(({ order_id }) => order_id === exp.order_id)
          order.express.detail = exp.detail
        })
      })
    },
    showChangeAddress(item) {
      this.oldAddressForm = {
        id: item.id,
        name: item.address.rec_name,
        phone: item.address.rec_phone,
        province_id: item.address.rec_province_id,
        city_id: item.address.rec_city_id,
        district_id: item.address.rec_district_id,
        street_id: item.address.rec_street_id,
        address: item.address.rec_address,
      }
      this.visibleAddress = true
    },
    showChangeMsg(id,msg) {
      this.msgForm.ids = id
      this.msgForm.des = msg
      this.visibleMsg = true
    },
    changeMsg() {
      var _this = this;
      if (_this.msgForm.des == '') {
        _this.$message.error('备注内容不能为空');
        return
      }
      _this.$util.api('/order/third/des', _this.msgForm, res => {
        if (res.code === 10000) {
          _this.tableData.forEach(item => {
            if (item.id === _this.msgForm.ids) {
              item.msg = _this.msgForm.des
            }
          })
          _this.$message.success(res.msg);
          _this.visibleMsg = false
          _this.msgForm = {ids:'',des:''}
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    changeExpress (order_id,express_id) {
      if (!order_id) {
        this.$message.error('请指定订单');
        return
      }
      if (!express_id) {
        this.$message.error('请指定快递公司');
        return
      }
      var _this = this
      _this.$util.api("/order/third/express", { ids:order_id,express_id:express_id }, (res) => {
        if (res.code === 10000) {
          _this.visibleExpress = false
          _this.$message.success(res.msg);
          setTimeout(function (f) {
            _this.getOrderList()
          },1000)
        } else {
          _this.$message.error(res.msg)
        }
      });
    },
    getExpressList(options) {
      if (!options) {
        this.$message.error("地址未填写完整");
        return;
      }
      this.$emit("getExpress", options);
    },
    generateOrder() {
      try {
        this.checkedList.forEach(id => {
          var index = this.tableData.findIndex((ro) => ro.id === id)
          if (index !== -1) {
            this.tableData[index].stores.forEach(storeItem => {
              storeItem.goods.forEach(goodsItem => {
                if (goodsItem.goods_id === 0) {
                  this.$message.error("订单"+this.tableData[index].sn+'有商品尚未匹配')
                  throw new Error('')
                }
              })
            })
          }
        })
      } catch (e) {
        return
      }

      this.$emit("submitOrder",this.checkedList)
    },
    showChangeExpress(item) {
      if (item.weight == 0) {
        this.$message.error("请检查商品重量");
        return;
      }
      this.getExpressList({weight:item.weight,platform:item.platform,...item.address})
      this.orderItem = item
      this.visibleExpress = true
    },
    showChangeGift() {
      this.visibleGift = true
    },
    showPay(id) {
      if (id) {
        this.payIds = [id]
      } else {
        this.payIds = this.checkedList
      }
      this.visiblePay = true
    },
    getOrderList() {
      this.$emit("getOrderList")
    }
  },

}
</script>

<style scoped>


::v-deep .ant-input,
::v-deep .ant-input-number {
  width: 250px;
  background: #fafafa;
}
.small_input {
  width: 160px;
}

.medium_input {
  width: 250px !important;
  height: 30px;
}
.short_width {
  width: 100px !important;
}
.large_input {
  width: 760px;
  height: 30px;
}

.flex_between {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 15%;
}
.second_row_container > td {
  /* display: flex; */
  background: #ffffff;
}

.ant-table-tbody > tr > td {
  padding: 10px;
}

.batch_container {
  height: 50px;
  display: flex;
  align-items: center;
  background: #ffffff;
  padding: 0 16px;
}
.ml16 {
  margin-left: 16px;
}
.ant-checkbox-group {
  width: 100%;
}


.first_row_container > td {
  background: #fff7e3;
}
.first_row_container {
  color: #333333;
  font-size: 13px;
  height: 40px;
  line-height: 30px;
}

.first_row_container > td > div > span:nth-of-type(1) {
  margin-left: 10px;
}
.first_row_container > td > div > span:nth-of-type(n + 2) {
  margin-left: 50px;
}

.order_form {
  width: 100%;
  padding-right: 13vw;
}
.order_form .ant-form-item {
  display: flex;
  flex-wrap: wrap;
}

.order_form >>> .ant-form-item-label {
  width: 80px;
}
.order_form >>> .ant-form-item-control-wrapper {
  width: calc(100% - 80px);
}

.order_form >>> .ant-form-item-children {
  position: relative;
}

.ems_charge_title {
  font-size: 16px;
  color: #333333;
  line-height: 14px;
  margin: 10px 0 15px;
  font-weight: 600;
}
.ems_name {
  height: 20px;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}
.ems_name strong {
  color: #fd5902;
  font-size: 14px;
}
.ant-radio-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.ant-radio-wrapper {
  width: 195px;
  display: flex;
  align-items: center;
  margin-left: 10%;
  margin-top: 15px;
}
.ml10 {
  margin-left: 10px;
}
.consignee {
  margin-left: 13px;
}
.goods_img {
  width: 100px;
  height: 100px;
  margin-right: 10px;
}
.goods_img img {
  display: block;
  width: 100px;
  height: 100%;
  position: static;
}
::v-deep .ant-descriptions {
  flex: 1;
}

::v-deep .ant-descriptions-item-label {
  min-width: 70px;
}

::v-deep .ant-descriptions-item-content {
  display: inline-flex;
  align-items: center;
}

.address_input_wrapper {
  display: flex;
}
.address_input_wrapper input {
  margin-right: 10px;
}
.address_input_wrapper ::v-deep .ant-input {
  flex: 1;
}
.address_input_wrapper ::v-deep .ant-input:nth-child(n + 2) {
  margin-left: 20px;
}
.address_input_wrapper ::v-deep .ant-input:nth-child(4) {
  flex: 4;
}
.ant-input-number {
  width: 88% !important;
}
.address_wrapper{
  margin-bottom: 20px;
  border-top: 1px solid #D8D8D8;
  padding-top: 5px;
}
.goods_info {
  margin-top: 10px;
  margin-bottom: 10px;
}
.express_wrapper {
  margin-left: 90px;
  margin-bottom: 20px;
}
.text_orange {
  font-weight: 600;
}
.goods_name {
  display: inline-block;
}
.second_row_container >>> tr.ant-descriptions-row>.ant-descriptions-item{
  padding-bottom: 10px !important;
}
.second_row_container>>> .ant-col-2{
  width: 100px;
}
.second_row_container>>> .ant-col-4{
  width: 26%;
  margin-left: 20px;
}
.list{
    display: block;
    margin-left: 16px;
}
.edit_button {
  margin-left: 10px;
  padding: 0px 5px 0px 5px;
  border: 1px solid;
  border-radius: 4px;
  font-size: 12px;
}
.title_font {
  font-size: 16px;
  font-weight: bold;
}

.width150 >>>.ant-descriptions-view{
  width: 150px !important;
}
.receiver_span {
  display: inline-block;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/deal/third/components/OrderList.vue